import { css } from "lit"

/**
 * Palette neutre partagée par le bloc "planning hebdomadaire" de la page d'accueil.
 * La palette générale de l'appli est teintée de bleu/violet (--hue: 250deg) ; ce bloc
 * s'appuie sur des gris neutres pour laisser la couleur aux seuls types de pokémon.
 * À étendre dans `static styles = [palettePlanning, css`...`]`.
 */
export const palettePlanning = css`
  :host {
    --planning-surface: light-dark(#f5f6f8, #1b1e24);
    --planning-surface-2: light-dark(#eceef2, #23262d);
    --planning-bordure: light-dark(#d9dde3, #333842);
    --planning-texte-doux: light-dark(#6b7280, #9aa1ac);
  }
`
